import { BaseDialog } from 'src/components/BaseDialog/BaseDialog';
import { ts } from 'src/utils/translate';

interface MissingCabinetDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function MissingCabinetDialog({ open, onConfirm, onCancel }: MissingCabinetDialogProps) {
  return (
      <BaseDialog
          open={open}
          title={ts('attention', 'Attention!')}
          cancelLabel={ts('plt_cancel', 'Cancel')}
          actionLabel={ts('ok', 'OK')}
          onAction={onConfirm}
          onClose={onCancel}
      >
        {ts('docu_cabinet_info', 'There is no electrical cabinet or rack cabinet in your project. We will temporarily place one in your project, but you can also place it on any floor overriding this placement.')}
      </BaseDialog>
  );
}
